export const PAGE_SIZE_OPTIONS = [5, 10, 25, 50] as const;

export const DEFAULT_PAGE_INDEX = 0;
export const DEFAULT_PAGE_SIZE = 5;
